import * as React from 'react'
import { Layout } from 'react-admin'
import Menu from './Menu'

const MfhLayout = (props) => (
  <Layout {...props} menu={Menu}>
    {process.env.REACT_APP_ENV !== 'prod' && <div className="version-banner">{process.env.REACT_APP_ENV} version</div>}
    {props.children}
  </Layout>
)

export default MfhLayout
